import { css } from 'styled-components';

import { THIN_SCROLLBAR } from './scrollbar';

/**
 * Terminal-style "mono box" chrome shared by fenced code, plain-text
 * fallback tables, and approval-request command previews: any raw
 * agent/system output that isn't rendered through a dedicated UI widget
 * defaults to this look, matching the app's raw-output aesthetic.
 *
 * Deliberately covers only the chrome (font, background, border, scroll) —
 * font-size/line-height/margin/padding vary by call site (e.g. an approval
 * card's command preview reads smaller than a chat message's fenced code),
 * so those stay local to each usage.
 */
export const MONO_BOX = css`
  font-family: var(--font-mono, monospace);
  background: rgba(var(--color-lightest), 0.06);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  overflow-x: auto;
  ${THIN_SCROLLBAR}
`;
